'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { List, Map as ImmutableMap } from 'immutable';
import { AttributionViews, EntityTypes } from 'AdsUI/lib/Constants';
import FilteredAndSortedCampaignReportingTable from 'AdsUI/components/campaign-reporting/FilteredAndSortedCampaignReportingTable';
import { withRouter } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { AdsSimpleDateRange } from '../../lib/AdsSimpleDateRange';

const getCampaignLink = entity => {
  return `accounts/${entity.network.toLowerCase()}/${entity.accountId}/campaigns/${entity.id}`;
};

const Footer = /*#__PURE__*/_jsx(NavMarker, {
  name: "CAMPAIGNS_TABLE_LOADED"
});

const CampaignsTable = ({
  campaignData,
  adAccounts,
  loaded,
  globalFilters,
  columns,
  lifecycleStageLabelsByStageId,
  campaigns,
  history,
  toggleCampaignStatus,
  hasWriteScope,
  hasRoiReportingScope,
  onColumnReorder,
  errorsByAdAccount,
  columnDisplayLabels,
  showFBStaleDataAlert = false
}) => {
  const {
    aggregateFunnel
  } = campaignData;
  const onClickEntity = useCallback(entity => history.push(getCampaignLink(entity)), [history]);
  return /*#__PURE__*/_jsx(FilteredAndSortedCampaignReportingTable, {
    earlyFetch: true,
    navMarkerFooter: Footer,
    loading: !loaded,
    columns: columns,
    lifecycleStageLabelsByStageId: lifecycleStageLabelsByStageId,
    campaignChildren: campaigns,
    entityType: EntityTypes.CAMPAIGN,
    globalFilters: globalFilters,
    adAccounts: adAccounts,
    onClickEntity: onClickEntity,
    toggleEntityStatus: toggleCampaignStatus,
    hasWriteScope: hasWriteScope,
    hasRoiReportingScope: hasRoiReportingScope,
    errorsByAdAccount: errorsByAdAccount,
    onColumnReorder: onColumnReorder,
    totals: aggregateFunnel,
    columnDisplayLabels: columnDisplayLabels,
    showFBStaleDataAlert: showFBStaleDataAlert
  });
};

CampaignsTable.proptypes = {
  campaigns: PropTypes.object,
  campaignData: PropTypes.object.isRequired,
  timeRange: PropTypes.instanceOf(AdsSimpleDateRange).isRequired,
  attributionView: PropTypes.oneOf(Object.keys(AttributionViews)).isRequired,
  adAccounts: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  columns: PropTypes.instanceOf(List).isRequired,
  lifecycleStageLabelsByStageId: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  hasWriteScope: PropTypes.bool.isRequired,
  hasRoiReportingScope: PropTypes.bool.isRequired,
  errorsByAdAccount: PropTypes.instanceOf(ImmutableMap).isRequired,
  onColumnReorder: PropTypes.func.isRequired,
  showFBStaleDataAlert: PropTypes.bool
};
export default withRouter(CampaignsTable);